import state from './listingState';
import ApiListing from './apiListing';

export default {
    namespaced: true,
    state() {
        return {
            ...state,
            pagination: {
                per_page: 50,
            }
        };
    },
    getters: {
        ...ApiListing.getters,

    },
    mutations: {
        ...ApiListing.mutations,
        
    },
    actions: {
        ...ApiListing.actions,
    }
};

    